export default "__VITE_ASSET__CnrZ2dR5__"